document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll(
    ".bc-1section, .bc-2section, .bc-3section, .item-new-container,.view-all-button,.collection-wrapper",
  );
  const images = document.querySelectorAll(".img-wrapper img");

  const observerOptions = {
    root: null, // ビューポートを基準
    rootMargin: "0px",
    threshold: 0.2, // 要素が20%表示されたら発火
  };

  const fadeInSections = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const children = entry.target.children;
        Array.from(children).forEach((child, index) => {
          setTimeout(() => {
            child.classList.add("fade-in");
          }, index * 500); // 順番にフェードイン（500ms間隔）
        });
        observer.unobserve(entry.target); // 一度だけ発火
      }
    });
  };

  const fadeInImages = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("fade-in");
        observer.unobserve(entry.target); // 一度だけ発火
      }
    });
  };

  // メディアクエリで画面幅を判定
  const mediaQuery = window.matchMedia("(max-width: 820px)");

  if (mediaQuery.matches) {
    // 820px以下の場合、スクロールイベントでトリガー
    const handleScroll = () => {
      sections.forEach((section) => {
        if (section.getBoundingClientRect().top < window.innerHeight * 0.8) {
          const children = section.children;
          Array.from(children).forEach((child, index) => {
            setTimeout(() => {
              child.classList.add("fade-in");
            }, index * 500);
          });
        }
      });

      images.forEach((image, index) => {
        if (image.getBoundingClientRect().top < window.innerHeight * 0.8) {
          setTimeout(() => {
            image.classList.add("fade-in");
          }, index * 200);
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
  } else {
    // 820px以上の場合、IntersectionObserverを使用
    const sectionObserver = new IntersectionObserver(
      fadeInSections,
      observerOptions,
    );

    sections.forEach((section) => {
      sectionObserver.observe(section);
    });

    const imageObserver = new IntersectionObserver(fadeInImages, {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    });

    images.forEach((image, index) => {
      imageObserver.observe(image);
      image.style.transitionDelay = `${index * 200}ms`; // 順番にフェードイン（200ms間隔）
    });
  }
});